<template>
    <div :id="uploadCenterName" class="staging">
        <form>
          <!-- transition="dialog-bottom-transition"  -->
          <v-dialog v-model="dialogDiscount" width="50%" class="pa-0 ma-0" style="z-index:91291921929">
            <v-card flat>
              <v-card-title>
                <span>Lizenzgebühr reduzieren</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogDiscount = false" color="black">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                Sie können an Channels- und Discountsmodell teilnehmen.<br>
                Buchen Sie touristische Beiträge und reduzieren Sie Ihre Lizenzgebühr.<br>
                <br><br>
                <span class="font-weight-bold">
                Bitte kontaktieren Sie uns.<br>
                Telefon 0851-988830
                </span>
              </v-card-text>
              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-dialog>
            <DialogDefault ref="dlgDefault"></DialogDefault>
            <DialogAddMediathekItem ref="dlgAddMedia" @addMedia="addMediaItemDone"></DialogAddMediathekItem>
            <DialogAddWeb ref="dlgAddWeb" @save="addURLItemDone"></DialogAddWeb>
            <DialogShowVideo ref="dlgVideo" :device="currentDevice" @onClose="refresh"></DialogShowVideo>
            <DialogItemSettings ref="dlgSettings" :device="currentDevice" @onClose="refresh"></DialogItemSettings>
            <DialogShareMediaItem ref="dlgShareMedia" @save="addMediaItemsDone"></DialogShareMediaItem>
            <DialogRemoveMediaItem ref="dlgRemoveMedia" @save="removeMediaItemDone"></DialogRemoveMediaItem>

            <input ref="iUpload" type="file" style="position: absolute;left:-1000px;">
            <v-card v-if="(currentDevice != null) && (items != null)">
              <v-row class="pa-0 mx-0">
                <v-col cols="12" xs="12" class="pa-0 mx-0">
                <v-toolbar dense color="cyan darken-3" dark style="height: 32px" flat>
                    <v-toolbar-title class="subtitle-2 pr-2" style="height: 39px">
                        <v-icon small v-if="!editName" @click="editName=!editName" class="iconWhite">edit</v-icon>&nbsp; &nbsp;
                        <v-icon small v-if="editName" @click="saveName" class="iconWhite">save</v-icon>&nbsp; &nbsp;
                    </v-toolbar-title>
                    <v-toolbar-title v-if="!editName" class="subtitle-2" style="height: 39px" @click="editName=!editName">{{currentDevice.stageName}}
                    </v-toolbar-title>
                    <v-text-field @keydown="kdName" v-if="editName" v-model="currentDevice.stageName" clearable style="max-width:280px;"></v-text-field>
                </v-toolbar>
                </v-col>
              </v-row>
                <v-row class="pt-2" v-if="cmpRights.stagePicVisible">
                  <v-col cols="12" sm="3" class="ml-4">
                    <!--<v-btn @click="dialogDiscount=true" color="primary">Discount</v-btn>-->
                  </v-col>
                  <v-col cols="12" sm="6" align="center">
                    <span style="color: #000000;font-size: 14px;">Ihre aktuelle Sendschleife</span>
                    <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" class="pl-2" color="cyan darken-3" @click.stop="dialogzoom = true" small>zoom_out_map</v-icon>
                    </template>
                    <span>Fullscreen Ansicht</span>
                  </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="3">

                  </v-col>
                </v-row>
                <v-row justify="center" align="center" class="xhover05" v-if="cmpRights.stagePicVisible">
                    <v-col cols="12" xs="12" align="center"> <!--sm="8" md="4" lg="3" style="text-align: center"-->
                      <v-row justify="center">
                        <v-col cols="12" xs="2" sm="1" align="right" style="margin-top:auto;margin-bottom:auto">
                            <v-icon @click="prev" color="#00838f">skip_previous</v-icon>
                        </v-col>
                        <v-col cols="12" xs="8" sm="8" align="center">
                            <div class="displayCard">
                                <v-card class="" justify="start" max-width="376px" flat>
                                    <img onerror="this.onerror=null; this.src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';"  :src="backgroundUrl" @click="openDialog2" style="max-height:320px;max-width:376px;min-height: 320px;min-width: 376px;" contain>
                                    <div v-if="showMoveable && showVideo && currentDevice" :key="mcIndex"
                                         class="monitor moveable"
                                         :style="getStyleMonitor(currentDevice)">
                                        <img v-if="currentDevice.playlist && currentDevice.currentTyp === 'IMAGE'"
                                             :style="getStyleMonitor(currentDevice)" :src="currentDevice.videoSrc">

                                        <video v-if="currentDevice.playlist && currentDevice.currentTyp === 'VIDEO'"
                                               @ended="onEnd(currentDevice)" :style="getStyleMonitor(currentDevice)"
                                               autoplay
                                               :src="currentDevice.videoSrc">
                                            {{currentDevice.videoSrc}}
                                        </video>

                                        <img v-if="currentDevice.playlist && currentDevice.currentTyp === 'WEB'"
                                             :style="getStyleMonitorWeb(currentDevice)" :src="currentDevice.videoSrc">
                                        <!--
                                        <iframe v-if="device.playlist && device.currentTyp === 'WEB' && showVideo" :src="device.videoSrc" class="frame" :style="getStyleMonitor(device)">
                                        </iframe>
                                        -->
                                    </div>
                                </v-card>
                            </div>
                        </v-col>
                        <v-col cols="12" xs="2" sm="1" align="left" style="margin-top:auto;margin-bottom:auto">
                            <v-icon @click="next" color="#00838f">skip_next</v-icon>
                        </v-col>
                      </v-row>
                    </v-col>
                </v-row>

                <v-row justify="center" v-if="cmpRights.stagePicVisible" class="mx-4">
                    <v-col cols="12">

                      <v-row v-if="false">
                        <v-col cols="12">
                          <v-btn
                              block
                              outlined
                              color="cyan darken-3"
                              dark
                              @click.stop="dialogzoom = true"
                          >
                            <v-icon>zoom_out_map</v-icon>
                          </v-btn>
                        </v-col>
                       </v-row>
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-toolbar-title class="body-2" v-if="myItemsWithoutPlaylist">
                            <span class="font-weight-bold">Anzahl Beiträge: {{myItemsWithoutPlaylist.length}}</span><br>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <span v-on="on" class="font-weight-bold" v-if="playListdata">Sendeschleife: {{fancyTimeFormat(playListdata.duration)}} </span>
                              </template>
                              <span>Dauer der Sendeschleife (hh:mm:ss)</span>
                            </v-tooltip>

                            <span class="font-weight-bold" v-if="playListdata && playListdata.maxLength !== 0" :style="getLengthStyle(playListdata)"> von {{fancyTimeFormat(playListdata.maxLength)}} </span>
                            <br>
                            <span class="font-weight-bold" v-if="playListdata">Eigene Beiträge:</span> <span class="font-weight-bold" :style="getAddStyle(currentDevice)">{{fancyTimeFormat(getDuration(currentDevice))}}</span><span class="font-weight-bold"> von </span> <span class="font-weight-bold">{{fancyTimeFormat(currentDevice.maxDuration)}} </span>
                            <br>
                            <!--<span class="font-weight-bold" v-if="cmpRights.lastPingVisible && playListdata">Letzte Rückmeldung: <span>{{tableUtils.convertToDateTime(device.lastHeartbeat)}}</span> </span><br>-->
                            <span class="font-weight-bold" v-if="cmpRights.statsVisible && statsData">Geräte: {{statsData.cntDevices}} </span>
                            <span class="font-weight-bold" v-if="cmpRights.statsVisible && statsData">Standorte: {{statsData.cntCompanies}} </span>
                            <span class="font-weight-bold" v-if="cmpRights.statsVisible && statsData">Links: {{statsData.cntLinked}} </span>
                          </v-toolbar-title>
                        </v-col>
                        <v-col cols="12" md="6" class="text-center" v-if="cmpRights.allowPicUpload">
                          <span class="text-none body-2" style="color:#080808" @click='onPickFile'>
                            Hier können Sie ein Bild ihres Schaufenster hochladen.<v-icon color="#00838f">cloud_upload</v-icon><br>Das erleichtert die Identifizierung des Displays bei mehreren Installationen.

                          </span>
                        </v-col>
                        <v-col cols="12" md="3" class="text-center" v-if="cmpRights.allowPicUpload">
                        </v-col>
                      </v-row>

                    </v-col>
                    <v-dialog
                            v-model="dialogzoom"
                            max-width="100%"
                            max-height="100%"
                            style="z-index: 1000;overflow: hidden;"
                    >
                        <v-card height="100%" class="pa-5">
                            <v-row justify="end">
                                <v-btn
                                        class="mr-5"
                                        icon
                                        color="cyan darken-3"
                                        text
                                        @click="dialogzoom = false"
                                >
                                    <v-icon>clear</v-icon>
                                </v-btn>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col cols="1">
                                    <v-icon @click="prev">skip_previous</v-icon>
                                </v-col>
                                <v-col cols="10">
                                    <v-card height="580px" style="text-align: center" flat>
                                        <div v-if="showMoveable && showVideo && currentDevice" :key="mcIndex"
                                             class="monitor previewPic">
                                            <img v-if="currentDevice.playlist && currentDevice.currentTyp === 'IMAGE'"
                                                 :src="currentDevice.videoSrc">

                                            <video v-if="currentDevice.playlist && currentDevice.currentTyp === 'VIDEO'"
                                                   @ended="onEnd(currentDevice)" autoplay
                                                   :src="currentDevice.videoSrc">
                                                {{currentDevice.videoSrc}}
                                            </video>

                                            <img v-if="currentDevice.playlist && currentDevice.currentTyp === 'WEB'"
                                                 :src="currentDevice.videoSrc">
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="1" align="right">
                                    <v-icon @click="next">skip_next</v-icon>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-dialog>
                </v-row>
                <div class="borderBottom mt-5 mx-8"></div>

                <v-row :key="listIndex">
                    <v-col cols="12" xs="4" sm="4" md="3" justify="center" class="pa-4" align="center">
                          <v-card
                              v-if="isAllowedUploadViaMaxLength(playListdata)"
                              class="text-center"
                              flat
                          >
                            <v-row justify="center pa-2 mt-6 ml-4">
                              <v-col cols="12">
                                <v-btn @click="uploadFile(currentDevice)" small class="text-none" outlined block  height="40" color="cyan darken-3">Datei hinzufügen</v-btn>
                              </v-col>
                              <v-col cols="12" v-if="false">
                                <v-btn @click="addURLItem(currentDevice)" small class="text-none" outlined block height="40"
                                       color="cyan darken-3">Webadresse hinzufügen
                                </v-btn>
                              </v-col>
                              <v-col cols="12">
                                <v-btn @click="openMediaDialog(currentDevice)" small class="text-none" outlined block height="40"
                                       color="cyan darken-3">Aus Mediathek hinzufügen
                                </v-btn>
                              </v-col>
                              <v-col id="makeMeBlue" cols="12">
                                <v-select
                                    item-color="#00838f"
                                    color="#00838f"
                                    v-model="channel"
                                    :items="filteredChannels"
                                    label="Channels"
                                    v-if="cmpRights.stageChannelSelectVisible"
                                    item-text="name"
                                    return-object
                                    @change="onChangeSelectedChannels"
                                    dense
                                    small-chips
                                    multiple
                                    outlined
                                >
                                </v-select>
                              </v-col>
                            </v-row>
                          </v-card>
                    </v-col>
                    <v-col cols="12" xs="8" sm="8" md="9">
                      <v-sheet class="mx-auto">
                        <v-slide-group show-arrows active-class="success" v-model="model">
                          <v-slide-item v-if="!isAllowedUploadViaMaxLength(playListdata)">
                            <v-card
                                color="white"
                                class="ma-4 text-center"
                                height="200"
                                width="200"
                            >

                              <v-row justify="center" class="mt-3">
                                <v-col cols="12">
                                  <v-icon color="cyan darken-3" x-large>warning</v-icon><br>
                                  Kein Upload mehr möglich.
                                </v-col>
                                <v-col>
                                  <span class="subtitle-2" style="color:red"> Ihre Maximal Länge ist erreicht. Bitte entfernen Sie zunächst ein Video</span>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-slide-item>

                          <v-slide-item v-for="(item, idx) in myItemsWithoutPlaylist" :key="item.id"
                                        v-slot:default="{ active }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-card
                                    v-on="on"
                                    :color="getColorBar(item)"
                                    min-width="240px"
                                    :class="getClass(idx, item)"

                                >
                                  <div v-if="item.readOnly" class="fromChannel">
                                    {{getChannelText(item)}}
                                  </div>
                                  <div v-if="!item.readOnly" style="color:transparent;">
                                  </div>
                                  <v-row class="ma-0 pa-0">
                                    <v-col cols="12">
                                      <v-system-bar window light>
                                        <v-icon v-if="item.readOnly" text color="cyan darken-3">
                                          list
                                        </v-icon>
                                        <v-icon v-if="item.active" text color="cyan darken-3">
                                          timelapse
                                        </v-icon>
                                        <span v-if="item.active">{{item.duration}} Sek.</span>
                                        <v-icon v-if="!item.active" text color="cyan darken-3">
                                          visibility_off
                                        </v-icon>

                                        <v-spacer></v-spacer>
                                        <center>
                                        {{item.type}}
                                        </center>
                                        <v-spacer></v-spacer>
                                        <v-icon text color="gree" v-if="!item.readOnly"
                                                @click="settings(item)">settings
                                        </v-icon>
                                        <v-icon text color="red" v-if="!item.readOnly"
                                                @click="deleteItemDialog(item)">delete
                                        </v-icon>
                                      </v-system-bar>
                                      <v-system-bar window light color="white">
                                        <span style="font-size: 0.75em;max-width: 320px">{{item.name}}</span>
                                      </v-system-bar>
                                    </v-col>
                                  </v-row>
                                  <v-container>
                                    <v-row justify="center" align="center" style="height: 200px">
                                      <v-col cols="12">
                                        <v-row justify="center" @click="settings(item)">
                                          <v-img v-if="item.type === 'WEB'"
                                                 :src="tableUtils.getImage(item)"
                                                 :lazy-src="tableUtils.getImageThumbUrl(item)"
                                                 contain
                                                 :alt="item.name"
                                                 max-width="120" max-height="120"></v-img>
                                          <v-img v-if="item.type === 'IMAGE'"
                                                 :src="tableUtils.getImage(item)"
                                                 :lazy-src="tableUtils.getImageThumbUrl(item)"
                                                 contain
                                                 :alt="item.name"
                                                 max-width="240" max-height="197"></v-img>
                                          <!-- -->
                                          <v-img v-if="item.type === 'VIDEO'"
                                                 :lazy-src="tableUtils.getImageThumbUrl(item)"
                                                 :src="tableUtils.getImage(item)"
                                                 contain
                                                 :alt="item.name"
                                                 max-width="240" max-height="197"></v-img>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                  <v-card-actions>
                                    <v-col cols="2" class="pa-0">
                                      <v-tooltip top v-if="item && !item.readOnly && idx !== 0">
                                        <template v-slot:activator="{ on }">
                                          <span v-on="on" ><v-icon @click="sortOrder(item, -1)">chevron_left</v-icon></span>
                                        </template>
                                        <span>Reihenfolge nach links schieben</span>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="8" class="pa-0 text-center">
                                      <!--
                                      <v-tooltip top v-if="item && !item.readOnly">
                                        <template v-slot:activator="{ on }">
                                          <span v-on="on" style="font-size: 8px;">
                                                  Position
                                          </span>
                                        </template>
                                        <span>Reihenfolge anpassen</span>
                                      </v-tooltip>
                                      -->
                                    </v-col>
                                    <v-col cols="2" class="pa-0" style="text-align: right">
                                      <v-tooltip top v-if="item && !item.readOnly">
                                        <template v-slot:activator="{ on }">
                                          <span v-on="on" ><v-icon @click="sortOrder(item, 1)">chevron_right</v-icon></span>
                                        </template>
                                        <span>Reihenfolge nach rechts schieben</span>
                                      </v-tooltip>

                                    </v-col>
                                  </v-card-actions>
                                </v-card>
                              </template>
                              <span v-html="getTooltip(item)"></span>
                            </v-tooltip>


                          </v-slide-item>
                          <v-slide-item>
                            <v-card
                                color="white"
                                class="text-center"
                                width="200"
                            >
                              <v-row justify="center pa-2 mt-8">
                                <v-col>
                                  &nbsp;
                                </v-col>
                              </v-row>
                            </v-card>

                          </v-slide-item>
                        </v-slide-group>
                      </v-sheet>
                    </v-col>
                </v-row>
            </v-card>
            <v-card v-else>
            <v-row class="pa-0 mx-0">
              <v-col cols="12" xs="12" class="pa-0 mx-0">
                <v-toolbar dense color="cyan darken-3" dark style="height: 32px" flat>
                  <v-toolbar-title class="subtitle-2 pr-2" style="height: 39px">
                    <v-icon small v-if="!editName" @click="editName=!editName" class="iconWhite">edit</v-icon>&nbsp; &nbsp;
                    <v-icon small v-if="editName" @click="saveName" class="iconWhite">save</v-icon>&nbsp; &nbsp;
                  </v-toolbar-title>
                  <v-toolbar-title v-if="!editName" class="subtitle-2" style="height: 39px"
                                   @click="editName=!editName">{{currentDevice.name}}
                  </v-toolbar-title>
                  <v-text-field @keydown="kdName" v-if="editName" v-model="currentDevice.name" clearable style="max-width:280px;"></v-text-field>
                </v-toolbar>
              </v-col>
            </v-row>
          </v-card>
            <br><br><br><br><br><br>
        </form>
    </div>
</template>

<script>
    import Vue from "vue";
    import DialogAddWeb from '@/components/module/dialogs/DialogAddWeb'
    import DialogShowVideo from '@/components/module/dialogs/DialogShowVideo'
    import DialogAddMediathekItem from '@/components/module/dialogs/DialogAddMediathekItem'
    import DialogItemSettings from "../module/dialogs/DialogItemSettings";
    import DialogShareMediaItem from "@/components/module/dialogs/DialogShareMediaItem.vue";
    import DialogRemoveMediaItem from "@/components/module/dialogs/DialogRemoveMediaItem.vue";
    import DialogDefault from "@/components/module/dialogs/DialogDefault.vue";

    var moment = require('moment');
    var _ = require('lodash')
    export default {
        components: {
          DialogDefault,
          DialogRemoveMediaItem, DialogShareMediaItem, DialogItemSettings, DialogAddWeb, DialogShowVideo, DialogAddMediathekItem},
        name: "WidgetDevice",
        props: ['startDevice', 'startCompanyGuid', 'adminView', 'pmap'],
        computed: {
            myItemsWithoutPlaylist() {
                var cmp = this
                return cmp.items.filter(item => {
                    return item.type !== 'PLAYLIST'
                })
            },
            filteredChannels() {
                var cmp = this
                if (!this.currentDevice) {
                    return this.channelList
                }
                return cmp.channelList.filter(item => {
                    return item.orientation === cmp.currentDevice.orientation
                })
            }
        },
        data() {
            return {
                on: {},
                on2: {},
                playListdata: {},
                statsData: null,
                cmpRights: {
                    allowPicUpload: false,
                    stagePicVisible: false,
                    stageChannelSelectVisible: false,
                    lastPingVisible: false,
                    statsVisible: false
                },
                editName: false,
                dialogzoom: false,
                tableUtils: require('./../tables/TableUtils').default,
                backgroundUrl: './static/Platzhalter.png',
                backgroundUrlDef: './static/Platzhalter.png',
                uploadCenterName: 'uploadCenter',
                dialogDiscount: false,
                uploadConfig: {
                    uploadUrl: '',
                    jQueryDivName: '#uploadCenter'
                },
                mcIndex: 0,
                listIndex: 0,
                channel: null,
                playlist: {},
                itemAdded: false,
                channelList: [{
                    id: '1',
                    text: 'Berge'
                }, {
                    id: '2',
                    text: 'Kreuzfahrten'
                }],
                items: null,
                showVideo: false,
                timerEnabled: false,
                currentDevice: null,
                progress: 0,
                numberOfItemsCard: '',
                showMoveable: false,
                titleGeraete: '-',
                playlistName: '-',
                model: null
            }
        },
        methods: {
            refresh(json) {
                if (json && json.pos) {
                    this.currentDevice.jsonMonitor.pos = json.pos
                }
                this.reload(this.currentDevice)
            },
            kdName(evt) {
                console.log('kdName', evt)
                if (evt.key === 'Enter') {
                    this.saveName()
                }
            },
            saveName() {
                console.log('saveDevice', this.currentDevice)
                let clone = JSON.parse(JSON.stringify(this.currentDevice))
                clone['playlist'] = null;
                debugger; // eslint-disable-line no-debugger

                Vue.prototype.$api.updateDevice(this.currentDevice.guid, clone, this.onItemUpdated)
            },
            onItemUpdated(d) {
                console.log('device saved', d)
                this.editName = false
            },
            checkTimer() {
                var dd = this.currentDevice
                if (!dd) return
                var diff = new Date().getTime() - dd.started

                if (dd.currentTyp === 'VIDEO') {
                    //
                } else if (dd.currentTyp === 'IMAGE') {
                    if (diff > dd.currentDuration * 1000) {
                        console.log('diffEnd')
                        this.onEnd(dd)
                    }

                } else if (dd.currentTyp === 'WEB') {
                    if (diff > dd.currentDuration * 1000) {
                        console.log('diffEnd')
                        this.onEnd(dd)
                    }
                }
                var cmp = this
                if (this.timerEnabled) {
                    setTimeout(() => {
                        cmp.checkTimer()
                    }, 1500);
                }
            },
            next: function () {
                this.onEnd(this.currentDevice)
            },
            prev: function () {
                var monitor = this.currentDevice
                monitor.playlist.index = monitor.playlist.index - 2
                if (monitor.playlist.index < -1) monitor.playlist.index = -1
                this.onEnd(monitor)
            },
            onChangeSelectedChannels: function (lst) {
                console.log('onChangeSelectedChannels', lst, this.items)
                var playlistItems = this.items
                var addChannels = []
                var removePlaylistItem = []
                var currentChannelList = lst
                var cmp = this
                // Prüfen welche Channels hinzugefügt werden müssen
                _.forEach(lst, function (channel) {
                    console.log('xchannel', channel)
                    var idx = _.findIndex(playlistItems, function (o) {
                        return o.localFileName === channel.guid;
                    });
                    if (idx > -1) {
                        console.log('xchannel already exists', channel)
                    } else {
                        console.log('xchannel is missing', channel)
                        addChannels.push(channel)
                    }
                })
                if (addChannels.length === 0) {

                    // Prüfen welche Channels entfernt werden müssen
                    _.forEach(this.channelList, function (channel) {
                        console.log('channel to delete ', channel)
                        var idx = _.findIndex(currentChannelList, function (o) {
                            return o.guid === channel.guid;
                        });
                        if (idx > -1) {
                            console.log('channel already exists', channel)
                        } else {
                            console.log('channel is missing', channel)
                            idx = _.findIndex(playlistItems, function (o) {
                                return o.localFileName === channel.guid;
                            });
                            if (idx > -1) {
                                console.log('but found in playlist')
                                removePlaylistItem.push(playlistItems[idx])
                            }
                        }
                    })
                }
                if (addChannels.length > 0) {
                    console.log('channels werden hinzugefügt', addChannels)
                    _.forEach(addChannels, function (channel) {
                        var pl = {
                            guid: channel.guid
                        }
                        Vue.prototype.$api.linkPlayListToPlayList(cmp.currentDevice.guidPlaylist, pl, function () {
                            Vue.prototype.$api.loadPlayListItems(cmp.currentDevice.guidPlaylist, cmp.onGetPlaylistItems)
                        })
                    })
                }
                if (removePlaylistItem.length > 0) {
                    console.log('channels werden entfernt', removePlaylistItem)
                    _.forEach(removePlaylistItem, function (item) {
                        cmp.deleteItem(item)
                    })
                }
            },
            toMB: function (bytes, decimals) {
                if (bytes == 0) return '0 Bytes';
                var k = 1024,
                    dm = decimals <= 0 ? 0 : decimals || 2,
                    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            fancyTimeFormat: function (time) {

                var d = function display(seconds) {
                    const format = val => `0${Math.floor(val)}`.slice(-2)
                    const hours = seconds / 3600
                    const minutes = (seconds % 3600) / 60

                    return [hours, minutes, seconds % 60].map(format).join(':')
                }
                return d(time)
            },
            toMinutes: function (duration) {
                var result = duration / 60
                result = result.toFixed(2)
                return result
            },
            getDuration: function (device) {
              let duration = 0
              _.forEach(device.playlist.items, function (item) {
                if (!item.readOnly) {
                  duration = duration + item.duration
                }
              })
              return duration
            },
            isAllowedToAdd: function (device) {
              return this.getDuration(device) < device.maxDuration || device.maxDuration === 0 || device.maxDuration === null
            },
            getAddStyle: function (device) {
                let style = "color: red;"
                let allowedToAdd = this.isAllowedToAdd(device)
                if (allowedToAdd) {
                  style = "color: green;"
                }
                return style
            },
            checkChannelsAlreadyAdded: function () {
                var addChannels = []
                var playlistItems = this.items
                // Prüfen welche Channels hinzugefügt werden müssen
                _.forEach(this.channelList, function (channel) {
                    console.log('channel', channel)
                    var idx = _.findIndex(playlistItems, function (o) {
                        return o.localFileName == channel.guid;
                    });
                    if (idx > -1) {
                        console.log('channel already exists', channel)
                        addChannels.push(channel)
                    } else {
                        console.log('channel is missing', channel)
                    }
                })
                this.channel = addChannels
            },
            openDialog2: function () {
                this.showVideo = false
                this.$refs.dlgVideo.open(this.currentDevice)
            },
            getBackgroundImageUrl: function (item) {
                var url = Vue.prototype.$config.HOST + '/media/devices/' + this.currentDevice.guid + '/' + item.imgBackground
                if ((item.imgBackground === 'none') || (item.imgBackground.length === 0)) {
                    url = this.backgroundUrlDef
                }
                console.log('getBackgroundImageUrl', url)
                return url
            },
            initDD: function () {
                if (window.jQuery(this.uploadConfig.jQueryDivName).length === 0) {
                    window.setTimeout(this.initDD, 1000)
                } else {
                    this.initDragAndDrop(this.uploadConfig, Vue.prototype.$eventHub)
                }
            },
            reload: function (device, companyGuid) {
                console.log('reload', device)
                this.device = device
                this.companyGuid = companyGuid
                if (this.currentDevice === null) {
                    console.log('reload prepare', device, companyGuid)
                    this.currentDevice = this.device
                    this.checkStageName()
                    if (this.currentDevice) {
                        this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/playlists/upload/' + this.currentDevice.guidPlaylist + '?active=1'
                    }
                    this.uploadConfig.onUploadProgress = this.onUploadProgress
                    this.uploadConfig.onUploadSuccess = this.onUploadSuccess
                    this.uploadConfig.device = device
                    Vue.prototype.$api.loadChannelsFromCompany(this.companyGuid, this.onGetChannelList)
                    this.initDD()
                }
                this.showVideo = false
                if (device && device.jsonMonitor) {
                    try {
                        if (typeof (device.jsonMonitor) !== 'object') {
                            device.jsonMonitor = JSON.parse(device.jsonMonitor)
                        }
                        if (device.jsonMonitor) {
                            if (device.jsonMonitor.pos) {
                                device.xx = device.jsonMonitor.pos.x
                                device.yy = device.jsonMonitor.pos.y
                                device.width = device.jsonMonitor.pos.w
                                device.height = device.jsonMonitor.pos.h
                            }
                        }
                    } catch (error) {
                        console.error('error', error, device.jsonMonitor)
                    }
                }
                this.currentDevice = device
                this.checkStageName()
                if (!this.currentDevice) {
                    this.items = []
                    return
                }
                this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/playlists/upload/' + this.currentDevice.guidPlaylist + '?active=1'
                this.backgroundUrl = this.getBackgroundImageUrl(this.currentDevice)
                Vue.prototype.$api.loadPlayList(this.currentDevice.guidPlaylist, this.onGetPlaylist)
                Vue.prototype.$api.getPlayListStats(this.currentDevice.guidPlaylist, this.onGetPlayListStats)
            },
            checkStageName: function () {
              if (this.currentDevice) {
                if (!this.currentDevice.stageName || this.currentDevice.stageName === '') {
                  this.currentDevice.stageName = this.currentDevice.name
                }
              }
            },
            openDialog: function () {
                this.showVideo = false
                this.$refs.dlgVideo.open()
            },
            openDialogHoch: function () {
                this.$refs.dlgVideoHoch.open()
            },
            onPickFile() {
                this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/devices/upload/' + this.currentDevice.guid + '/background'
                console.log('upload', this.uploadConfig)
                this.$refs.iUpload.click()
            },
            getChannelText: function (item) {
                return '' + item.fromPlayList
            },
            settings: function (item) {
                // var cmp = this
                if (!item.readOnly) {
                    this.$refs.dlgSettings.open({}, item)
                }

            },
            deleteItemDialog: function (item) {
              this.$refs.dlgRemoveMedia.open({
                title: 'Weiteren Geräten entfernen',
                description: 'Sie können diesen Eintrage weiteren Geräten entfernen'
              }, this.pmap[this.currentDevice.orientation], this.currentDevice.guid, {
                item: item
              })

            },
            deleteItem: function (item) {
                const cmp = this
                Vue.prototype.$api.deletePlaylistItem(this.currentDevice.guidPlaylist, item.guid, function () {
                    Vue.prototype.$api.loadPlayListItems(cmp.currentDevice.guidPlaylist, cmp.onGetPlaylistItems)
                })
            },
            editItem: function (item) {
                this.$router.push('/PlaylistItem/' + item.guid)
            },
            onGetPlayListStats(data) {
                this.statsData = data
            },
            onGetPlaylist(data) {
                console.log('playlist', data)
                this.playlist = data
                Vue.prototype.$api.loadPlayListItems(this.currentDevice.guidPlaylist, this.onGetPlaylistItems)
            },
            getImageUrl(item) {
                var url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + item.localFileName
                return url
            },
            onEnd(monitor) {
                if (!this.timerEnabled) return
                console.log('onEnd', monitor.playlist, monitor.playlist.index)

                this.nextItemPlayList(monitor)
                monitor.videoSrc = this.getPlaylistItem(monitor)
                this.device.videoSrc = this.getPlaylistItem(monitor)
                this.mcIndex = this.mcIndex + 1
            },
            nextItemPlayList(monitor) {
                if (monitor.playlist) {
                    monitor.playlist.index = monitor.playlist.index + 1
                    if (monitor.playlist.index > monitor.playlist.items.length - 1) {
                        monitor.playlist.index = 0
                    }
                    console.log('nextItemPlayList', monitor.playlist.index)
                    var item = monitor.playlist.items[monitor.playlist.index]
                    if (item) {
                        if (item.type === 'PLAYLIST') {
                            this.nextItemPlayList(monitor)
                        }
                    }
                }
            },
            getWebUrl(item) {
                var url = item.localFileName
                return url
            },

            getLengthStyle(pData) {
                if (pData && pData.maxLength !== 0) {
                    if (pData.duration > pData.maxLength) {
                        return 'color: red !important;'
                    } else {
                        return 'color: green !important;'
                    }
                }
            },
            isAllowedUploadViaMaxLength(pData) {
                if (pData && pData.maxLength !== 0) {
                    if (pData.duration > pData.maxLength) {
                        return false
                    }
                }
                return true
            },
            updateCounter(items) {
                var listData = {
                    cnt: 1,
                    duration: 0,
                    maxLength: 0,
                    size: 0
                }
                for (var index in items) {
                    var row = items[index]
                    row.formattedDatetime = moment(row.activeFrom).format("DD.MM.YYYY HH:mm")
                    row.formattedDatetimeTill = moment(row.activeTill).format("DD.MM.YYYY HH:mm")
                    console.log('row', row)
                    if (row.active) {
                        listData.duration = listData.duration + row.duration * 1
                    }
                    listData.size = listData.size + row.size
                    listData.maxLength = this.playlist.maxLength
                }
                listData.cnt = this.items.length
                this.playListdata = listData
            },

            onGetPlaylistItems(items) {
                console.log('onGetPlaylistItems', items)
                this.items = items

                this.updateCounter(items)

                this.checkChannelsAlreadyAdded()

                this.device.playlist = {
                    index: 0,
                    items: items
                }
                this.device.videoSrc = this.getPlaylistItem(this.device)
                this.timerEnabled = true
                console.log('onGetPlaylist source now: ', this.device.videoSrc)
                var cmp = this
                window.setTimeout(cmp.initMonitor, 100)
                cmp.showVideo = true
                this.mcIndex = this.mcIndex + 1
                this.listIndex = this.listIndex + 1
            },
            getPlaylistItem(monitor) {
                if (monitor.playlist) {
                    var item = monitor.playlist.items[monitor.playlist.index]
                    if (item) {
                      if (item.type === 'PLAYLIST') {
                        this.nextItemPlayList(monitor)
                        item = monitor.playlist.items[monitor.playlist.index]
                      }
                      var url = ''
                      if (item.type === 'VIDEO') {
                        url = Vue.prototype.$api.getVideoUrl(item)
                      } else if (item.type === 'IMAGE') {
                        url = this.tableUtils.getImage(item)
                        if (item.duration === 0) {
                          item.duration = 1000
                        }
                      } else if (item.type === 'WEB') {
                        url = this.tableUtils.getImage(item)
                        if (item.duration === 0) {
                          item.duration = 1000
                        }
                      } else {
                        url = this.tableUtils.getImage(item)
                        if (item.duration === 0) {
                          item.duration = 1000
                        }
                      }
                      monitor.currentSrc = url
                      monitor.currentTyp = item.type
                      monitor.currentDuration = item.duration
                      monitor.started = new Date().getTime()
                      return url
                    }
                }
                return ''
            },

            getClass: function (idx) {
                if (idx === 0 && this.itemAdded) {
                    return 'itemAdded pa-2 mx-2'
                } else {
                    return 'pa-2 mx-2'
                }
            },
            getColorBar: function (item) {
                var css = ''
                if (item.fromPlayList) {
                    css += 'lightGRAY lighten-5'
                }
                if (item.type === 'PLAYLIST') {
                    css += 'red lighten-5'
                }
                css += 'lighten-5'

                return css
            },
            getTooltip: function (item) {
                var css = 'Eigenes Media Item'
                if (item.fromPlayList) {
                    css = 'Item aus fremder Playlist'
                }
                if (!item.active) {
                    css += ' <br>Nicht aktiv'
                }
                css += ' <br>Spielzeit in Sekunden:' + this.fancyTimeFormat(item.duration)
                css += ' <br>(' + this.tableUtils.getFileName(item) + ')'
                return css
            },
            getColor: function (item) {
                var css = ''
                var cpl = '#ee0d10'
                if (item.fromPlayList) {
                    css += 'color:' + cpl + ';'
                }
                if (item.type === 'PLAYLIST') {
                    css += 'color:' + cpl + '; font-weight: bold;'
                }
                return css
            },
            getStyleMonitor(device) {
                var item = device
                var css = 'left:' + item.xx + 'px'
                css += ';top:' + item.yy + 'px;z-index:1000;'
                css += 'width:' + item.width + 'px;'
                css += 'height:' + item.height + 'px;object-fit:fill;border:1px solid black; background-color:white'
                console.log('getStyleMonitor', css)
                return css
            },
            getStyleMonitorWeb(device) {
                var item = device
                var css = 'left:' + item.xx + 'px'
                css += ';top:' + item.yy + 'px;z-index:1000;'
                css += 'width:' + item.width + 'px;'
                css += 'height:' + item.height + 'px;object-fit:contain;border:1px solid black'
                console.log('getStyleMonitor', css)
                return css
            },
            getImageThumbUrl(item) {
                if (item.type === 'WEB') {
                    return 'static/www.jpg'
                } else if (item.type === 'PLAYLIST') {
                    return 'static/Playlist.jpg'
                }
                if (item.thumb && item.thumb.length > 10) {
                    return 'data:image/png;base64, ' + item.thumb
                }
                return 'static/Missing.jpg'
            },

            getImage: function (item) {
                if (item.type === 'WEB') {
                    return 'static/www.jpg'
                } else if (item.type === 'PLAYLIST') {
                    return 'static/Playlist.jpg'
                }
                var fName = item.localFileName.substring(0, item.localFileName.lastIndexOf('.')) + 'thumb.jpg'
                var url = Vue.prototype.$config.HOST + '/media/' + item.guidPlaylist + '/' + fName
                return url
            },
            onFilePicked(event) {
                const files = event.target.files
                if (files[0] !== undefined) {
                    this.fileName = files[0].name
                    // Check validity of file
                    if (this.fileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    // If valid, continue
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.url = fr.result
                        this.fileObject = files[0] // this is an file that can be sent to server...

                    })
                } else {
                    this.fileName = ''
                    this.fileObject = null
                    this.url = ''
                }
            },
            onUploadProgress: function (id, percent) {
                console.log(id, percent)
                Vue.prototype.$eventHub.$emit('OnProgress', percent)
                this.progress = percent
            },
            onUploadSuccess(id, data) {
                console.log('upload done', data)
                if (data.success) {
                    if (data.data) {
                        this.currentDevice.imgBackground = data.data.savedFileName
                        this.mcIndex = this.mcIndex + 1
                    }
                }
                this.itemAdded = true
                this.reload(this.currentDevice, Vue.prototype.$api.getCredentials().data.guidParent)

                Vue.prototype.$eventHub.$emit('OnProgress', 100)
            },
          removeMediaItemDone: function (d) {
            let data = d.customData
            let devices = d.selected
            let md5OfItemToDelete = data.item.md5
            const cmp = this
            for (let di in devices) {
              let device = devices[di]
              const idx = _.findIndex(device.playlist.items, function (o) {
                return o.md5 === md5OfItemToDelete;
              });
              if (idx > -1) {
                const guidItemToDelete = device.playlist.items[idx]
                Vue.prototype.$api.deletePlaylistItem(device.guidPlaylist, guidItemToDelete.guid, function () {
                  console.log('item removed ', device.playlist, guidItemToDelete.guid)
                  cmp.reload(device, cmp.companyGuid)
                })
              }
            }

          },
          addMediaItemsDone: function (d) {
            let data = d.customData
            let devices = d.selected
            let cmp = this
            // debugger; // eslint-disable-line no-debugger

            for (let di in devices) {
              let device = devices[di]
              let newOrder = 100
              if (device.playlist.items.length > 0) {
                newOrder = (device.playlist.items[0].orderNr) - 100
              }
              let newItem = JSON.parse(JSON.stringify(data.item))
              newItem.orderNr = newOrder
              let ed = device
              Vue.prototype.$api.createPlaylistItemByMedia(device.guidPlaylist, newItem, function () {
                cmp.$emit('reloadDevice', {
                  guid: ed.guid,
                  device: ed,
                  companyGuid: cmp.companyGuid
                })
              })
            }
          },

          addMediaItemDone: function (data) {
            if ((this.pmap[this.currentDevice.orientation].length) > 0) {
              this.$refs.dlgShareMedia.open({
                title: 'Weiteren Geräten zuweisen',
                description: 'Sie können das Video weiteren Endgeräten mit dem gleichen Format zuweisen'
              }, this.pmap[this.currentDevice.orientation], this.currentDevice.guid, data)
            }
            else {
              let newOrder = 100
              if (this.items.length > 0) {
                newOrder = (this.items[0].orderNr) - 100
              }

              let newItem = JSON.parse(JSON.stringify(data.item))
              newItem.orderNr = newOrder

              var cmp = this
              Vue.prototype.$api.createPlaylistItemByMedia(this.currentDevice.guidPlaylist, newItem, function (data) {
                console.log('createPlaylistItemByMedia', data)
                cmp.reload(cmp.currentDevice, cmp.companyGuid)
              })

            }
          },


          addURLItemDone: function (data) {
                let newOrder = 100
                if (this.items.length > 0) {
                    newOrder = (this.items[this.items.length - 1].orderNr) + 100
                }

                var newItem = {
                    orderNr: newOrder,
                    name: 'Web URL',
                    localFileName: data.url,
                    localAbsoluteFileName: '',
                    type: 'WEB',
                    mime: 'web',
                    size: 0,
                    duration: 10,
                    md5: '',
                    config: '',
                    thumb: '',
                    active: 1
                }
                console.log('addURLItem', newItem)
                var cmp = this
                Vue.prototype.$api.createPlaylistItem(this.currentDevice.guidPlaylist, newItem, function (data) {
                    console.log('createPlaylistItem', data)
                    cmp.reload(cmp.currentDevice)
                })
            },
            sortOrder: function (item, index) {
                let fIndex = _.findIndex(this.items, function (o) {
                    console.log('fIndex', o.guid, item.guid)
                    return o.guid === item.guid
                })

                if ((index < 0) && (fIndex === 0)) return
                if ((index > 0) && (fIndex >= this.items.length - 1)) return

                var nextItem = null
                if (index > 0) {
                    for (var i = fIndex + 1; i < this.items.length; i++) {
                        var entry = this.items[i]
                        if (entry.type !== 'PLAYLIST') {
                            nextItem = entry
                            item.orderNr = nextItem.orderNr + 1
                            break;
                        }
                    }
                } else {
                    for (var ii = fIndex - 1; ii >= 0; ii--) {
                        var entry2 = this.items[ii]
                        if (entry2.type !== 'PLAYLIST') {
                            nextItem = entry2
                            item.orderNr = nextItem.orderNr - 1
                            break;
                        }
                    }
                }
                const that = this
                //
                Vue.prototype.$api.updatePlayListItemOrderNr(item.guid, item, function () {
                    Vue.prototype.$api.loadPlayList(that.currentDevice.guidPlaylist, that.onGetPlaylist)
                })
            },
            initMonitor: function () {
                if (this.currentDevice && this.currentDevice.jsonMonitor) {
                    try {
                        if (typeof (this.currentDevice.jsonMonitor) !== 'object') {
                            this.currentDevice.jsonMonitor = JSON.parse(this.currentDevice.jsonMonitor)
                        }
                        if (this.currentDevice.jsonMonitor) {
                            if (this.currentDevice.jsonMonitor.pos) {
                                this.currentDevice.xx = this.currentDevice.jsonMonitor.pos.x
                                this.currentDevice.yy = this.currentDevice.jsonMonitor.pos.y
                                this.currentDevice.width = this.currentDevice.jsonMonitor.pos.w
                                this.currentDevice.height = this.currentDevice.jsonMonitor.pos.h
                            } else {
                                this.currentDevice.xx = 0
                                this.currentDevice.yy = 0
                                this.currentDevice.width = 84
                                this.currentDevice.height = 128
                            }
                        }
                    } catch (error) {
                        console.error('error', error, this.currentDevice.jsonMonitor)
                    }
                }
                var cmp = this
                window.setTimeout(function () {
                    cmp.showMoveable = true
                    cmp.checkTimer()
                }, 200)
                console.log('initMonitor', this.currentDevice)
            },
            checkIsAllowed: function (device) {
              if (!this.isAllowedToAdd(device)) {
                this.$refs.dlgDefault.open({
                  title: 'Nicht erlaubt',
                  description: 'Sie haben die maximale Sendeschleife bereits ausgeschöpft. Erlaubt sind ' + device.maxDuration + ' Sekunden'
                })
                return false
              }
              return true
            },
            uploadFile: function (device) {
              if (!this.checkIsAllowed(device)) return
              window.jQuery(this.ddConfig.jQueryDivName).find('input').click()
            },
            addURLItem: function (device) {
              if (!this.checkIsAllowed(device)) return
                this.$refs.dlgAddWeb.open();
            },
            openMediaDialog: function (currentDevice) {
              if (!this.checkIsAllowed(currentDevice)) return
              this.$refs.dlgAddMedia.open(currentDevice);
            },

            onGetChannelList(data) {
                console.log('data', data)
                this.channelList = data
            },
            getUploadUrl: function(config) {

                if (this.isAllowedToAdd(config.device)) {
                  config.uploadErrorMessage = ''
                  return config.uploadUrl
                } else {
                  config.uploadErrorMessage = 'Sie haben die maximale Sendeschleife bereits ausgeschöpft. Erlaubt sind ' + config.device.maxDuration + ' Sekunden'
                  return ''
                }
            },
            initDragAndDrop(config, eventHub) {
                console.log('init drag and drop', config, window.jQuery(config.jQueryDivName))
                config.eventHub = eventHub
                config.uploadErrorMessage = ''
                this.ddConfig = config
                const cmp = this
                window.jQuery(config.jQueryDivName).dmUploader({
                    url: function () {
                      return cmp.getUploadUrl(config)
                    },
                    fileName: 'files',
                    dataType: 'json',
                    headers: {},
                    allowedTypes: '*',
                    maxFileSize: 100 * 1024 * 1024,
                    extFilter: 'mp4;jpg;png;mov;mpeg',
                    onInit: function () {
                        console.log('onInit uploader')
                    },
                    onBeforeUpload: function (id) {
                        // updateFileStatus(id, 'uploading', 'Uploading...')
                        console.log(id)
                        config.eventHub.$emit('lockScreen')
                    },
                    onNewFile: function (id, file) {
                        config.eventHub.$emit('unlockScreen')
                        console.log(id, file)
                    },
                    onComplete: function () {
                        console.log('upload complete')
                        config.eventHub.$emit('unlockScreen')
                    },
                    onUploadProgress: function (id, percent) {
                        if (config.onUploadProgress) config.onUploadProgress(id, percent)
                    },
                    onUploadSuccess: function (id, data) {
                        if (config.onUploadSuccess) config.onUploadSuccess(id, data)
                        cmp.$eventHub.$emit('unlockScreen')
                    },
                    onUploadError: function (id, message) {
                        cmp.$eventHub.$emit('unlockScreen')
                        cmp.$refs.dlgDefault.open({
                          title: 'Upload Fehler',
                          description: config.uploadErrorMessage + '(' + message + ')'
                        })
                    },
                    onFileTypeError: function (file) {
                      console.log('onFileTypeError', file)
                      cmp.$eventHub.$emit('unlockScreen')
                      config.uploadErrorMessage = 'Dateitype nicht erlaubt.  Erlaubt sind (mp4;jpg;png;mov;mpeg)'
                      cmp.$refs.dlgDefault.open({
                        title: 'Upload Fehler',
                        description: config.uploadErrorMessage
                      })
                    },
                    onFileSizeError: function (file) {
                      console.log('onFileSizeError', file)
                      cmp.$eventHub.$emit('unlockScreen')
                      config.uploadErrorMessage = 'Ihre Datei ist zu gross. Erlaubt sind maximal 100 Megabyte.'
                      cmp.$refs.dlgDefault.open({
                        title: 'Upload Fehler',
                        description: config.uploadErrorMessage
                      })
                    },
                    onFileExtError: function (file) {
                        console.log('onFileExtError', file)
                      cmp.$eventHub.$emit('unlockScreen')
                      config.uploadErrorMessage = 'Dateitype nicht erlaubt.  Erlaubt sind (mp4;jpg;png;mov;mpeg)'
                      cmp.$refs.dlgDefault.open({
                        title: 'Upload Fehler',
                        description: config.uploadErrorMessage
                      })
                    },
                    onFallbackMode: function (message) {
                      cmp.$refs.dlgDefault.open({
                        title: 'Upload Fehler',
                        description: message + config.uploadErrorMessage
                      })
                    }
                })
            }
        },
        beforeDestroy() {
            this.timerEnabled = false
        },
        deactivated() {
            this.timerEnabled = false
        },
        mounted() {
            this.uploadCenterName = 'uploadCenter' + new Date().getTime()
            this.uploadConfig.jQueryDivName = '#' + this.uploadCenterName
            this.showVideo = false
            this.itemAdded = false
            if (!this.adminView) {
                this.reload(this.startDevice, Vue.prototype.$api.getCredentials().data.guidParent)
            }
            if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_STAGE_UPLOAD_PICTURE')) {
                this.cmpRights.allowPicUpload = true
            }
            if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_STAGE_IMG_VISIBLE')) {
                this.cmpRights.stagePicVisible = true
            }
            if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_STAGE_CHANNELS_VISIBLE')) {
                this.cmpRights.stageChannelSelectVisible = true
            }
            if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_STAGE_LAST_PING_VISIBLE')) {
                this.cmpRights.lastPingVisible = true
            }
            if (Vue.prototype.$apiRight.hasRight('RIGHT_COMP_STAGE_STATISTIC_VISIBLE')) {
                this.cmpRights.statsVisible = true
            }


        }
    }
</script>

<style scoped>
    .fromChannel {
        background-color: #2fc4b6;
        text-align: center;
        font-weight: bolder;
        color: white;
        width: 100%;
    }

    .itemAdded {
        border: 4px solid #023b7e;
    }

    .addCardtext {
        font-size: 10px;
    }

    .lightGRAY {
        background-color: #f4f4f5;
    }
</style>
